import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { TranslocoLoader } from '@jsverse/transloco'

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
    private http = inject(HttpClient)

    getTranslation(langPath: string) {
        return this.http.get(`/i18n/${langPath}.json`)
    }
}
